export const uk = {
    'accept-button': 'Включить',
    'simple-progress-hint': 'Включаем автотаргетинг',
    'simple-title': 'Включите автотаргетинг',
    'title-hint':
        'Рекомендация показывается, потому что в ваших объявлениях не настроены ключевые фразы или завышено значение CPC'
};
